"use client";

import { FormEvent, useEffect, useState } from "react";
import { useRouter } from "next/navigation";
import { haptic } from "@kit/hooks/useHaptic";
import { button } from "@/lib/tokens";

const TOKEN_KEY = "codegem-api-token";

export default function Home() {
  const router = useRouter();
  const [token, setToken] = useState("");
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const tg = window.Telegram?.WebApp;
    if (tg) { tg.ready(); tg.expand(); }
    const start = new URLSearchParams(window.location.search).get("tgWebAppStartParam")
      ?? tg?.initDataUnsafe?.start_param ?? "";
    // Telegram launch (signed initData OR startapp deep-link) is already trusted →
    // route straight in, preserving the startapp "<session>[-stream]" routing.
    // The token gate is ONLY the public, non-Telegram front door.
    const authed = !!tg?.initData || !!start || !!sessionStorage.getItem(TOKEN_KEY);
    if (authed) {
      const sess = start.split("-")[0] || "liza";
      // "-tools" теперь открывает единый CLI-пейн поверх flow (роут /agents/tools удалён).
      const page = start.includes("-stream") ? "stream" : "flow";
      const pane = start.includes("-tools") ? "&pane=cli" : "";
      const qs = start ? `&tgWebAppStartParam=${encodeURIComponent(start)}` : "";
      router.replace(`/agents/${page}?session=${sess}${qs}${pane}`);
      return;
    }
    setReady(true);
  }, [router]);

  function submit(e: FormEvent) {
    e.preventDefault();
    const clean = token.trim();
    if (!clean) return;
    sessionStorage.setItem(TOKEN_KEY, clean);
    haptic("success");
    router.replace("/agents/flow?session=codegem");
  }

  if (!ready) return null;

  return (
    <main style={{ minHeight: "100dvh", padding: 24, display: "grid", placeItems: "center", background: "var(--tg-theme-bg-color, #0f1115)", color: "var(--tg-theme-text-color, #eef2ff)" }}>
      <form onSubmit={submit} style={{ width: "min(420px, 100%)", display: "grid", gap: 16 }}>
        <div style={{ display: "grid", gap: 8 }}>
          <p style={{ margin: 0, fontSize: 12, letterSpacing: ".16em", textTransform: "uppercase", color: "var(--tg-theme-hint-color, #8b93a7)" }}>Code Gem</p>
          <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.1 }}>Введите API-токен</h1>
          <p style={{ margin: 0, color: "var(--tg-theme-hint-color, #8b93a7)", lineHeight: 1.45 }}>Публичный вход. Токен пока живёт в sessionStorage — серверная проверка ключей подключается отдельным шагом.</p>
        </div>
        <input
          value={token}
          onChange={(e) => setToken(e.target.value)}
          placeholder="cg-..."
          autoComplete="off"
          inputMode="text"
          aria-label="API token"
          style={{ width: "100%", boxSizing: "border-box", border: "1px solid color-mix(in srgb, var(--tg-theme-hint-color, #8b93a7) 32%, transparent)", borderRadius: 'var(--cg-radius-lg)', padding: "16px 16px", background: "var(--tg-theme-secondary-bg-color, #171b24)", color: "inherit", fontSize: 16, outline: "none" }}
        />
        <button type="submit" disabled={!token.trim()} className="btn btn-primary"
          style={{ opacity: token.trim() ? 1 : button.disabled.opacity, cursor: token.trim() ? "pointer" : "default" }}>
          Открыть мини-апп
        </button>
      </form>
    </main>
  );
}
